/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Book_SessionInputs */

const en_fulfillment_book_session = /** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a Session`)
};

const id_fulfillment_book_session = /** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Sesi`)
};

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const es_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const fr_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const de_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const ja_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const zh_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const ar_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const it_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const ru_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const pt_fulfillment_book_session = en_fulfillment_book_session;

/** @type {(inputs: Fulfillment_Book_SessionInputs) => LocalizedString} */
const ko_fulfillment_book_session = en_fulfillment_book_session;

/**
* | output |
* | --- |
* | "Book a Session" |
*
* @param {Fulfillment_Book_SessionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_book_session = /** @type {((inputs?: Fulfillment_Book_SessionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Book_SessionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_book_session(inputs)
	if (locale === "es") return es_fulfillment_book_session(inputs)
	if (locale === "fr") return fr_fulfillment_book_session(inputs)
	if (locale === "de") return de_fulfillment_book_session(inputs)
	if (locale === "ja") return ja_fulfillment_book_session(inputs)
	if (locale === "zh") return zh_fulfillment_book_session(inputs)
	if (locale === "ar") return ar_fulfillment_book_session(inputs)
	if (locale === "id") return id_fulfillment_book_session(inputs)
	if (locale === "it") return it_fulfillment_book_session(inputs)
	if (locale === "ru") return ru_fulfillment_book_session(inputs)
	if (locale === "pt") return pt_fulfillment_book_session(inputs)
	return ko_fulfillment_book_session(inputs)
});